// 🌟 VIDEO HELPER — YouTube ya direct video (mp4/webm) dono handle karne ke liye
// Backend se video kisi bhi field mein aa sakta hai, isliye multiple possible
// field names ko check karte hain taaki jaise hi API mein video add ho, UI khud
// pick kar le — kisi extra code change ki zaroorat na pade.

const YOUTUBE_REGEX =
  /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/;

/**
 * Diya gaya URL YouTube link hai ya nahi
 */
export function isYouTubeUrl(url) {
  if (!url || typeof url !== "string") return false;
  return YOUTUBE_REGEX.test(url);
}

/**
 * YouTube URL se video ID nikalta hai
 */
export function getYouTubeId(url) {
  if (!url) return null;
  const match = url.match(YOUTUBE_REGEX);
  return match ? match[1] : null;
}

/**
 * YouTube ka embeddable player URL banata hai (autoplay + mute + loop support ke sath)
 */
export function getYouTubeEmbedUrl(url, { autoplay = true, muted = true, loop = true, controls = true } = {}) {
  const id = getYouTubeId(url);
  if (!id) return null;

  const params = new URLSearchParams({
    autoplay: autoplay ? "1" : "0",
    mute: muted ? "1" : "0",
    controls: controls ? "1" : "0",
    playsinline: "1",
    rel: "0",
    modestbranding: "1",
  });

  if (loop) {
    params.set("loop", "1");
    params.set("playlist", id); // YouTube ko loop ke liye playlist param bhi chahiye
  }

  return `https://www.youtube.com/embed/${id}?${params.toString()}`;
}

/**
 * Ek single product object se video URL nikalne ki koshish karta hai.
 * Backend field ka naam abhi fix nahi hai, isliye sabse common possible
 * naamon ko cover kiya hai — jo bhi mile wahi use ho jayega.
 */
export function extractProductVideo(product) {
  if (!product) return null;

  const candidates = [
    product?.video,
    product?.videoUrl,
    product?.video_url,
    product?.youtubeUrl,
    product?.youtube_url,
    product?.detail?.videos?.[0],
    product?.detail?.video,
    Array.isArray(product?.videos) ? product.videos[0] : null,
    Array.isArray(product?.gallery?.videos) ? product.gallery.videos[0] : null,
  ];

  const found = candidates.find((c) => typeof c === "string" && c.trim().length > 0);
  return found || null;
}

/**
 * Products ki ek list se, order maintain karte hue, unique video URLs
 * ki list nikalta hai (category page ke video blocks ke liye).
 */
export function extractVideosFromProducts(products = []) {
  const seen = new Set();
  const result = [];

  products.forEach((product) => {
    const video = extractProductVideo(product);
    if (video && !seen.has(video)) {
      seen.add(video);
      result.push(video);
    }
  });

  return result;
}

/**
 * Video type detect karta hai — 'youtube' | 'file' | null
 */
export function getVideoType(url) {
  if (!url) return null;
  return isYouTubeUrl(url) ? "youtube" : "file";
}
